//External
import React, { useEffect, useRef, useState } from "react";
import { Button } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
//Internal
import TheSpecials from "../thespecials";
import ResultsFilters from "components/results-filters";
import {
  clearCategoryBrandColorSeatPriceValue,
  clearVehicleList,
  getFilterInput,
  getLoadMoreData,
  getSearchResultsVehicles,
  setSelectedPage,
  setSelectedSlug,
  setVehicleList,
  setVehicleMetaData,
} from "../../store/actions";

import noCarFound from "../../public/assets/images/no-car-found.png";
import { get_cookie, page_limit } from "utils";

/*******************
  @Purpose :  used for Brand vehicle
  @Parameter : {brandCategorydetail,currentLocationId,slug1,slug2,slug3,totalRecord,vehiclesList,vehiclesMetaData,whichPage}
  @Author : INIC
 *******************/
const BrandVehicle = ({
  brandCategorydetail,
  currentLocationId,
  slug1,
  slug2,
  slug3,
  whichPage,
  brandBannerInfo,
}) => {
  const dispatch = useDispatch();
  const vehiclesList = useSelector((state) => state?.common?.vehiclesList);
  const vehiclesMetaData = useSelector(
    (state) => state?.common?.vehiclesMetaData
  );
  const totalRecord = useSelector((state) => state?.common?.totalRecord);
  const [showFilterLine, setShowFilterLine] = useState(false);
  const [showButton, setShowButton] = useState(false);
  const [sortBy, setSortBy] = useState("DESC");
  const [isLoadingMore, setIsLoadingMore] = useState(false);
  const [loadMoreError, setLoadMoreError] = useState(false);
  const loadMoreRef = useRef();
  const isFetchingMoreRef = useRef(false);

  // Show filter options in page
  const [totalLen, setTotalLen] = useState("");
  const [brandCategoryList, setBrandCategoryList] = useState();
  const [colorList, setColorList] = useState();
  const [priceBounds, setPriceBounds] = useState({ min: 0, max: 0 });

  const [selectedCategories, setSelectedCategories] = useState([]);
  const [selectedBrands, setSelectedBrands] = useState([]);
  const [selectedColors, setSelectedColors] = useState([]);
  const [selectedSeats, setSelectedSeats] = useState([]);
  const [priceRange, setPriceRange] = useState({ min: null, max: null });
  const [isFiltersDialogOpen, setIsFiltersDialogOpen] = useState(false);
  // Every vehicle at this location within the page's locked brand/category,
  // with no other filter applied - the single source ResultsFilters reads
  // its counts and zero-result option hiding from, computed client-side
  // instead of each dropdown/checkbox firing its own network request. See
  // the effect below (keyed on the locked slug, not the user's picks).
  const [availabilityPool, setAvailabilityPool] = useState([]);
  const skipNextFilterFetch = useRef(true);

  const [titlePart1, setTitlePart1] = useState();
  const [titlePart2, setTitlePart2] = useState();
  const [isMobileApp, setIsMobileApp] = useState();

  const isBrandPage = whichPage === "brand";
  const lockedFilters = isBrandPage
    ? { brandSlugs: [slug3] }
    : { categorySlugs: [slug3] };

  const handleLoadMore = () => {
    const nextUrl = vehiclesMetaData?.links?.next;
    if (!nextUrl || isFetchingMoreRef.current) return;
    isFetchingMoreRef.current = true;
    setIsLoadingMore(true);
    setLoadMoreError(false);
    dispatch(getLoadMoreData(nextUrl))
      .catch(() => setLoadMoreError(true))
      .finally(() => {
        isFetchingMoreRef.current = false;
        setIsLoadingMore(false);
      });
  };

  useEffect(() => {
    const sentinel = loadMoreRef.current;
    if (!sentinel) return;

    const observer = new IntersectionObserver(
      (entries) => {
        if (
          entries[0].isIntersecting &&
          vehiclesMetaData?.links?.next &&
          !isLoadingMore &&
          !loadMoreError
        ) {
          handleLoadMore();
        }
      },
      { rootMargin: "200px" }
    );

    observer.observe(sentinel);
    return () => observer.disconnect();
  }, [vehiclesMetaData?.links?.next, isLoadingMore, loadMoreError]);

  function scrollTo() {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
    setShowButton(false);
  }
  useEffect(() => {
    window.addEventListener("scroll", () => {
      if (window.scrollY > 300) {
        setShowButton(true);
      } else {
        setShowButton(false);
      }
    });
  }, []);

  useEffect(() => {
    let str;
    let len;
    let firstPart = [];
    let secondPart = [];
    str = brandBannerInfo.title.split(" ");
    len = str.length;
    if (brandBannerInfo.title.toLowerCase().includes("miami")) {
      for (let i = 0; i < len - 1; i++) {
        firstPart.push(str[i]);
      }
      secondPart.push(str[len - 1]);
    } else {
      for (let i = 0; i < len - 2; i++) {
        firstPart.push(str[i]);
      }
      secondPart.push(str[len - 2]);
      secondPart.push(str[len - 1]);
    }
    setTitlePart1(firstPart.join(" "));
    setTitlePart2(secondPart.join(" "));
  }, [brandBannerInfo.title]);

  useEffect(() => {
    setIsMobileApp(get_cookie("is_mobile_app"));
  }, []);

  const filterClickCount = useSelector(
    (state) => state?.common?.filterClickCount
  );

  useEffect(() => {
    if (filterClickCount) setIsFiltersDialogOpen(true);
  }, [filterClickCount]);

  const fetchFilteredVehicles = () => {
    dispatch(
      getSearchResultsVehicles(currentLocationId, {
        categorySlugs: selectedCategories,
        brandSlugs: selectedBrands,
        minPrice: priceRange.min ?? undefined,
        maxPrice: priceRange.max ?? undefined,
        seats: selectedSeats,
        colorIds: selectedColors,
        page: 1,
        sortBy,
        ...lockedFilters,
      })
    )
      .then((res) => {
        dispatch(clearVehicleList(""));
        dispatch(setVehicleList(res?.data || []));
        dispatch(setVehicleMetaData(res));
        setLoadMoreError(false);
      })
      .catch(() => {
        dispatch(clearVehicleList(""));
        dispatch(setVehicleMetaData({}));
      });
  };

  useEffect(() => {
    if (!currentLocationId) return;
    if (skipNextFilterFetch.current) {
      skipNextFilterFetch.current = false;
      return;
    }
    fetchFilteredVehicles();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    selectedCategories,
    selectedBrands,
    selectedColors,
    selectedSeats,
    priceRange,
    sortBy,
  ]);

  useEffect(() => {
    if (!currentLocationId) return;

    dispatch(
      getSearchResultsVehicles(currentLocationId, {
        ...lockedFilters,
        page: 1,
        pageLimit: 500,
      })
    )
      .then((res) => setAvailabilityPool(res?.data || []))
      .catch(() => setAvailabilityPool([]));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentLocationId, slug3, whichPage, dispatch]);

  const handleSortChange = (value) => {
    setSortBy(value);
  };

  useEffect(() => {
    dispatch(setSelectedPage(whichPage));
    dispatch(setSelectedSlug(slug3));
    dispatch(clearCategoryBrandColorSeatPriceValue());
    setBrandCategoryList("");
    setColorList("");
    setTotalLen("");
    setSortBy("DESC");
    setLoadMoreError(false);

    skipNextFilterFetch.current = true;
    setSelectedCategories([]);
    setSelectedBrands([]);
    setSelectedColors([]);
    setSelectedSeats([]);
    setPriceRange({ min: null, max: null });

    dispatch(getFilterInput(currentLocationId, slug3, whichPage)).then(
      (res) => {
        const options = isBrandPage ? res?.categories : res?.brands;
        setBrandCategoryList(options || []);
        setColorList(res?.colors || []);
        // Round to a cleaner $100 step for the slider's own endpoints (e.g.
        // an actual $1,243 low becomes a $1,200 floor) rather than showing
        // whatever odd dollar amount the API returns.
        setPriceBounds({
          min: Math.floor((parseInt(res?.price?.min, 10) || 0) / 100) * 100,
          max: Math.ceil((parseInt(res?.price?.max, 10) || 0) / 100) * 100,
        });
        setTotalLen((options?.length || 0) + (res?.colors?.length || 0));
      }
    );
  }, [slug3]);

  useEffect(() => {
    window.addEventListener("scroll", didScrollPage, 10);
    return () => {
      window.removeEventListener("keydown", didScrollPage);
    };
  }, []);

  /*******************
  @Purpose : used for scroll page
  @Parameter : {}
  @Author : INIC
  *******************/
  const didScrollPage = (e) => {
    let headerStickyOffset = 725;
    if (window.screen.width < 768) {
      headerStickyOffset = 515;
    }
    if (window.scrollY > headerStickyOffset) {
      setShowFilterLine(true);
    } else {
      setShowFilterLine(false);
    }
  };

  /*******************
  @purpose : Render HTML/ React Components
  @Author : INIC
  ******************/
  return (
    <>
      {/* vehicle list : Start */}
      {/* bg-gray */}
      <section
        className="py-60 category-list position-relative"
        id="brand-list"
      >
        {isMobileApp !== "yes" && (
          <div className="custom-container">
            <div className="banner-title">
              <h1 className="main-title fw-title fw-medium d-flex flex-wrap">
                <span className="mr-2">{titlePart1}</span>
                <span>{titlePart2}</span>
              </h1>
            </div>
          </div>
        )}

        <div
          className={`filter-section-wrap  ${isMobileApp === "yes" ? "make-mobile" : ""
            } filter-item ${isMobileApp === "yes" ? "cmd-filter-top" : ""} ${showFilterLine ? "filtersticky" : ""
            }`}
          id="filterOptionWrapper"
        >
          <div className="custom-container">
            {totalLen > 0 && totalRecord > 6 && (
              <ResultsFilters
                categoryList={isBrandPage ? brandCategoryList : []}
                brandList={isBrandPage ? [] : brandCategoryList}
                colorList={colorList}
                priceBounds={priceBounds}
                selectedCategories={selectedCategories}
                setSelectedCategories={setSelectedCategories}
                selectedBrands={selectedBrands}
                setSelectedBrands={setSelectedBrands}
                selectedColors={selectedColors}
                setSelectedColors={setSelectedColors}
                selectedSeats={selectedSeats}
                setSelectedSeats={setSelectedSeats}
                priceRange={priceRange}
                setPriceRange={setPriceRange}
                pool={availabilityPool}
                isFiltersDialogOpen={isFiltersDialogOpen}
                setIsFiltersDialogOpen={setIsFiltersDialogOpen}
                baseFilters={lockedFilters}
                hiddenFilters={isBrandPage ? ["brands"] : ["categories"]}
              />
            )}
          </div>
        </div>
        <div className="custom-container" id="mainWrapper">
          <div className="search-results-header d-flex align-items-center justify-content-end">
            <div className="sort-by-dropdown">
              <label htmlFor="sort-by-select">Sort by:</label>
              <select
                id="sort-by-select"
                value={sortBy}
                onChange={(e) => handleSortChange(e.target.value)}
              >
                <option value="DESC">Highest to lowest</option>
                <option value="ASC">Lowest to highest</option>
              </select>
            </div>
          </div>
          <section className="the-special bg-transparent" id="blogs-wrapper">
            <TheSpecials
              data={vehiclesList}
              slug1={slug1}
              slug2={slug2}
              slug3={slug3}
              flag="otherPage"
              whichPage={whichPage}
            />

            <div
              ref={loadMoreRef}
              className="search-results-load-more-sentinel"
            />

            {isLoadingMore && (
              <p className="search-results-loading">Loading more...</p>
            )}

            {loadMoreError && !isLoadingMore && (
              <div className="search-results-loading">
                <p className="mb-3">Something went wrong while loading more vehicles.</p>
                <Button
                  variant="outline-primary"
                  className="text-uppercase ff-hel-med"
                  onClick={handleLoadMore}
                >
                  Retry
                </Button>
              </div>
            )}
            {vehiclesList.length > 0 ? (
              ""
            ) : (
              <div className="text-center">
                <h2 className="mb-0 font-42 ff-hel-reg visible-hidden h-0 sr-only">
                  No cars found.
                </h2>
                <img
                  src={noCarFound}
                  width={660}
                  height={400}
                  objectFit="contain"
                  alt="No cars found"
                />
              </div>
            )}
          </section>
        </div>

        {/* Back to top option */}
        {vehiclesList.length > page_limit && showButton && (
          <div className="btt-option-wrapper" onClick={scrollTo}>
            {/* Show below element only if there is above 4+ Blog Listing Cards */}
            <div className="btt-option">
              <div className="btt-option">
                <span className="icon icon-arrow-up"></span>
              </div>
            </div>
          </div>
        )}
      </section>
      {/* Category list : End */}

    </>
  );
};
export default BrandVehicle;
